import { useSelector } from 'react-redux';
import { getHeader, getIsProductlistCustomBrand } from 'views/ProductlistPage/selectors';
import styles from './styles.scss';
import { NO_ELEMENT } from 'utils';

export const Title = () => {
  const header = useSelector(getHeader);
  return <h1 className={styles.heading}>{header}</h1>;
};

export const TitleSection = () => {
  const hide = useSelector(getIsProductlistCustomBrand);
  return hide ? NO_ELEMENT : <Title />;
};
